export const getGenericNewTableHeader = ({
  key,
  header,
  size,
  minSize,
  isFilter = false,
  filterVariant = "",
  isSortable = false,
  isResizable = true,
  isPin = false,
  isDragable = true,
  maxSize,
  isOrderable = true,
  isHidden = true,
}) => {
  return {
    accessorKey: key,
    header: header,
    size: size,
    enableSorting: isSortable,
    enableResizing: isResizable,
    enablePinning: isPin,
    enableColumnDragging: isDragable,
    enableColumnOrdering: isOrderable,
    enableColumnFilter: isFilter,
    minSize: minSize,
    maxSize: maxSize,
    enableHiding: isHidden,
    filterVariant: filterVariant,
  };
};
